import type {
  FieldLogOperatorPresence,
  FieldLogRecordingPresence,
} from '@/features/field-log/types/fieldLogList';

export function operatorPresenceSelectValue(value: 'present' | 'missing' | undefined) {
  return value ?? 'all';
}

export function operatorPresenceFromSelect(value: string): 'present' | 'missing' | undefined {
  return value === 'present' || value === 'missing' ? value : undefined;
}

export function recordingPresenceSelectValue(
  value: boolean | undefined,
): FieldLogRecordingPresence {
  if (value === true) return 'recording';
  if (value === false) return 'completed';
  return 'all';
}

export function recordingPresenceFromSelect(value: string): boolean | undefined {
  if (value === 'recording') return true;
  if (value === 'completed') return false;
  return undefined;
}

export function isOperatorPresence(
  value: string,
): value is Exclude<FieldLogOperatorPresence, 'all'> {
  return value === 'present' || value === 'missing';
}
